import styled from "styled-components";

export const ConfirmPlacementWrapper = styled.div`
header{
    border: 1px solid #BEC7CB;
    background: #fff;
    padding: 12px 18px;
    border-radius: 8px;
    display: grid;
    grid-template-columns:repeat(6, 1fr);
    grid-gap: 20px;
    .items-wrapper {
    display: flex;
    flex-direction: column;
    grid-row-gap: 2px;
    p {
    margin: 0;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #7E8A90;
    &:not(:first-child){
      background-color: #F4F6F6;
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      white-space: nowrap;
      height: 32px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      color: #212A2F;
      border-radius: 2px;
      padding: 3px 12px;
      & > div{
        width: 100%;
      }
    }
}
}
}
.product-item-wrapper {
    display: flex;
    align-items: flex-start;
    grid-gap: 10px;
    img {
    width: 40px;
    height: 28px;
    object-fit: contain;
}
.product-item {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
}
.content-wrapper {
    display: grid;
    grid-template-columns: 3fr 1fr;
    grid-gap: 24px;
    margin-top: 24px;
.cards-container {
    border: 1px solid #ECEFF1;
    border-radius: 4px;
    background: #ffff;
    padding: 12px;
    .active-item-wrapper {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    background: #1565D8;
    padding: 12px;
    border-radius: 6px;
    .item {
    display: flex;
    flex-direction: column;
    grid-row-gap: 2px;
    p {
    margin: 0px;
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    color: #ECEFF1;
    &:not(:first-child) {
    font-weight: 600;
    color: #ffff;
}
}
}
}
.products-cards{
display: flex;
flex-direction: column;
grid-row-gap: 8px;
margin-top: 12px;
/* height: auto; */
/* min-height: 200px; */
/* max-height: calc(100vh - 305px); */
height: calc(100vh - 438px);
overflow: auto;

.cards-items {
    display: flex;
    flex-direction: column;
    grid-row-gap: 8px;
    border: 2px solid #ECEFF1;
    background-color: #F5FBFF;
    padding: 12px;
    border-radius: 4px;
    width: 470px;
    .item {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    grid-gap: 24px;
    .cards-header {
    display: flex;
    align-items: baseline;
    grid-gap: 24px;
    p {
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    margin: 0;
    color: #808183;
    width: 100%;
}
}
}
.row-items {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-gap: 12px;
    .items {
    display: flex;
    flex-direction: column;
    p {
    margin: 0px;
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    color: #808183;
    &:not(:first-child) {
    color: #535E63;
    font-weight: 600;
}
&.fc-address{
    width: 3vw;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
}
}
}
}
}
}
.table-content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
  h2 {
    margin: 0;
  }
}
h2{
font-weight: 600;
font-size: 20px;
line-height: 18px;
margin: 0;
color: #1565D8;
}
}
.work-order-placement .progress-container {
    min-width: 150px;
}
`;